import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "game-frame" }
const _hoisted_2 = ["src"]

import {onMounted, onUnmounted} from "vue";
import {useRoute, useRouter} from "vue-router";
import {api} from "@/service/APIClient";
import {reactive} from "@vue/reactivity";
import {useStore} from "vuex";
import {Currency} from "@/models/enum/Currency";


export default /*@__PURE__*/_defineComponent({
  __name: 'GameWrapper',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const store = useStore()
const state = reactive({
  url: null as string|null,
  liveUpdateInterval: null as number|any
});


const altenteCallbacks = (t: any) => {
  if (!t.data.data) {
    return;
  }

  if (!t.data.data.isSupportsOperatorCallbacks || "altenteSlotGetSource" === t.data.type) switch (t.data.type) {
    case "altenteSlotGetSource":
      t.source.postMessage({type: "altenteSlotSetSource"}, "*");
      break;

    case "altenteSlotReload":
    case "altenteSlotGoToLobby":
    case "altenteSlotBackHistory":
      router.push({name: "home"})
      break;
    case "altenteSlotGameAction":
      if (!t.data.data.action || !t.data.data.action.bet || !t.data.data.action.lines) {
        break;
      }
      let bet = parseInt(t.data.data.action.bet);
      let lines = parseInt(t.data.data.action.lines);
      console.log(t.data.data)
      const newBalance = parseInt(store.getters.getBalance(Currency.GOLD_COIN)) - (lines * bet)
      store.dispatch('setBalance', newBalance.toString())

      break;
    case "altenteSlotGameActionResult":
      if (!t.data.data.result) {
        break;
      }

      if (t.data.data.result.nextStep !== 'spin') {
        break;
      }

      if (!t.data.data.result.balance) {
        break;
      }

      store.dispatch('setBalance', t.data.data.result.balance.amount)
      console.log(t.data.data)
      break;
    default:
      console.log(t.data.type, t.data.data)
  }
};

window.addEventListener('message', altenteCallbacks);

onMounted(async () => {
  const gameId = route.params.id as unknown as number
  const resp = await api.call.games.auth(gameId)
  state.url = resp.url

  state.liveUpdateInterval = setInterval(async () => {
    api.call.live.tournaments().then((resp) => store.dispatch('setLiveTournaments', resp))
  }, 10000);
})

onUnmounted(() => {
  clearInterval(state.liveUpdateInterval);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("iframe", {
      height: "100%",
      width: "100%",
      src: _unref(state).url
    }, null, 8, _hoisted_2)
  ]))
}
}

})